// @flow

// Types
import type { Asset } from 'fc-model-assets/types'

// Libs
import { createSelector } from 'reselect'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import { assets$ } from 'fc-assets'
import selectedSubfieldId$ from 'hfty-soil-jobs-dom/src/selectors/selectedSubfieldId'
import tableOperation$ from 'hfty-soil-jobs-dom/src/selectors/tableOperation'

export default createSelector(
  [assets$, tableOperation$, selectedSubfieldId$],
  function (assets: Asset, tableOperation: Object, subfieldId: number): Asset {
    const fieldId = traverse([subfieldId, 'parent'], { default: undefined })(assets)
    return traverse([fieldId], { default: null })(assets)
  }
)
